// 9-color palette per design spec (Specialty Color Assignment Rules).
// Order is fixed — specialty at index 0 always gets color 1, etc.
export const SPECIALTY_COLOR_PALETTE = [
    '#50BDFF',  // 1 Sky
    '#74BF60',  // 2 Spring
    '#FF6400',  // 3 Orange
    '#00989F',  // 4 Turquoise
    '#FFA100',  // 5 Gold
    '#00A562',  // 6 Emerald
    '#599E84',  // 7 Spruce     65% lightened per UX spec
    '#FFC387',  // 8 Sandstone
    '#A98975',  // 9 Earth
];

export const SPECIALTY_COLOR_FALLBACK = '#969696';

export const MAX_SPECIALTY_SELECTIONS = SPECIALTY_COLOR_PALETTE.length;

/**
 * Returns a stable color for a specialty based on its position in the
 * selected specialty list. Same index → same color across re-renders.
 */
export function getSpecialtyColor(index: number): string {
    return SPECIALTY_COLOR_PALETTE[index % SPECIALTY_COLOR_PALETTE.length] ?? SPECIALTY_COLOR_FALLBACK;
}

/**
 * Builds a map of specialtyName → color for the given selected specialty names.
 */
export function buildSpecialtyColorMap(specialtyNames: string[]): Record<string, string> {
    const map: Record<string, string> = {};
    specialtyNames.forEach((name, i) => {
        map[name] = getSpecialtyColor(i);
    });
    return map;
}
